// extracted by mini-css-extract-plugin
module.exports = {"abcjs-score":"abc_abcjs-score__6IB1C"};